import { Logger } from '@common/logic';

const DEFAULT_LOG_PREFIX = 'nav-login-panel';
const DEFAULT_LOG_NAME = 'logger';

export const getLogger = (name?: string) => new Logger({
  logPrefix: DEFAULT_LOG_PREFIX,
  name: name || DEFAULT_LOG_NAME,
  options: {
    disableInWeb: false,
  },
});

export const DefaultLogger = new Logger({
  logPrefix: DEFAULT_LOG_PREFIX,
  name: DEFAULT_LOG_NAME,
  enableStackTrace: false,
  options: {
    disableInWeb: false,
  },
});
